// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"PromptVariablesModal_modalWrapper__2y3M_","likeAnimation":"PromptVariablesModal_likeAnimation__36vJe"};